// K+
// import Constants from "../../api/Constants";

export default{
    name: "SectionPlainText",
    data(){
        return{

        }
    },
    props: {
        description: {
            type: String
        }
    }
}
